// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ukOgs","inputWrap":"Table_inputWrap__F-MfE","col":"Table_col__30O11","bmiTooltip":"Table_bmiTooltip__EPNr2"};